module.exports = __webpack_public_path__ + "media/images/error-js-ed6d051664b9bad43789d4ac4618b677.svg";